/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { GetTraceabilityCampaignStatsQueryResponse } from "../types/GetTraceabilityCampaignStats.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getTraceabilityCampaignStatsQueryKey = () =>
  [{ url: "/v1/product/get-traceability-campaign-stats" }] as const

export type GetTraceabilityCampaignStatsQueryKey = ReturnType<
  typeof getTraceabilityCampaignStatsQueryKey
>

/**
 * @summary Get traceability campaign stats
 * {@link /v1/product/get-traceability-campaign-stats}
 */
export async function getTraceabilityCampaignStats(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetTraceabilityCampaignStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/get-traceability-campaign-stats`,
    ...requestConfig,
  })
  return res
}

export function getTraceabilityCampaignStatsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getTraceabilityCampaignStatsQueryKey()
  return queryOptions<
    ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTraceabilityCampaignStats({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get traceability campaign stats
 * {@link /v1/product/get-traceability-campaign-stats}
 */
export function useGetTraceabilityCampaignStats<
  TData = ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
  TQueryData = ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
  TQueryKey extends QueryKey = GetTraceabilityCampaignStatsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getTraceabilityCampaignStatsQueryKey()

  const query = useQuery(
    {
      ...getTraceabilityCampaignStatsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
